import { Tooltip, TooltipTrigger, TooltipContent } from "../ui/tooltip";
import { FormControl, FormItem, FormLabel, FormMessage } from "../ui/form";
import { FormField } from "../ui/form";
import { Input } from "../ui/input";
import { Eye, EyeOff, InfoIcon } from "lucide-react";
import { Button } from "../ui/button";
import { useState } from "react";

export function FormInputField({
  control,
  label,
  fieldName,
  className,
  type,
  disabled,
  defaultValue = "",
  info,
  required,
  placeholder,
}: {
  control: any;
  fieldName: string;
  label?: string;
  className?: string;
  type?: React.HTMLInputTypeAttribute;
  disabled?: boolean;
  defaultValue?: string;
  info?: string;
  required?: boolean;
  placeholder?: string;
}) {
  const [inputType, setType] = useState(type);
  if (disabled) {
    return (
      <FormItem className={className}>
        {label && (
          <FormLabel asChild className="leading-normal">
            <div>
              <span>
                {label}
                {required && <span className="ml-1 text-red">*</span>}
              </span>
              {info && (
                <Tooltip>
                  <TooltipTrigger>
                    <InfoIcon className="ml-2 cursor-pointer h-4 w-4 text-gray-500 bottom-0" />
                  </TooltipTrigger>
                  <TooltipContent>{info}</TooltipContent>
                </Tooltip>
              )}
            </div>
          </FormLabel>
        )}
        <FormControl>
          <Input
            disabled={disabled}
            type={type}
            value={defaultValue}
            placeholder={placeholder}
          />
        </FormControl>
        <FormMessage />
      </FormItem>
    );
  }
  return (
    <FormField
      control={control}
      name={fieldName}
      render={({ field }) => (
        <FormItem className={className}>
          {label && (
            <FormLabel asChild className="leading-normal">
              <div>
                <span>
                  {label}
                  {required && <span className="ml-1 text-red">*</span>}
                </span>
                {info && (
                  <Tooltip>
                    <TooltipTrigger>
                      <InfoIcon className="ml-2 cursor-pointer h-4 w-4 text-gray-500 bottom-0" />
                    </TooltipTrigger>
                    <TooltipContent>{info}</TooltipContent>
                  </Tooltip>
                )}
              </div>
            </FormLabel>
          )}
          <FormControl>
            <div className="relative">
              <Input
                {...field}
                type={inputType}
                onChange={(e) => {
                  const value = e.target.value;
                  field.onChange(type === "number" ? Number(value) : value); // Convert to number if type is number
                }}
                className={type === "password" ? "pr-14" : ""}
              />
              {type === "password" && (
                <Button
                  className="absolute top-0 right-0"
                  type="button"
                  variant="ghost"
                  onClick={() =>
                    setType((prev) =>
                      prev === "password" ? "text" : "password"
                    )
                  }
                >
                  {inputType === "password" ? <Eye /> : <EyeOff />}
                </Button>
              )}
            </div>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
